export default {
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    emitCloseDialog() {
      this.$emit('update:visible', false);
    },
    initialDataFromProp(data, shadow) {
      const keys = Object.keys(data);
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        // eslint-disable-next-line no-param-reassign
        data[key] = shadow[key];
      }
    },
    notifyDataChanged() {
      this.$message({
        type: 'success',
        message: '操作成功',
      });
      this.$emit('data-changed');
    },
  },
};
